import { useContext } from 'react'

import { ExternoContext } from '@provider/FollowUpFornecedor/ExternoProvider'

import { IExternoContext } from '@base/@types/providers/FollowUpFornecedor/ExternoProvider'

export default function useFollowUpExterno(): IExternoContext {
  return useContext(ExternoContext)
}
